import GammeProduitDetailController from './gamme.produit.detail.controller';

export default {
    template: require('./gamme.produit.detail.html'),
    controller: GammeProduitDetailController
};
